import { Component, Input, OnInit } from '@angular/core';
import { DownloadCRTDLComponent } from '../download-crtdl/download-crtdl.component';
import { FeasibilityQueryValidationService } from 'src/app/service/Criterion/FeasibilityQueryValidation.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SaveDataQueryModalService } from 'src/app/service/SaveDataQueryModal.service';
import { map, Observable, Subscription } from 'rxjs';
import { UploadService } from 'src/app/service/Upload/Upload.service';

@Component({
  selector: 'num-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.scss'],
})
export class ActionBarComponent implements OnInit {
  @Input() showUpload = true;
  @Input() showDownload = true;
  @Input() showSave = true;

  downloadAllowed$: Observable<boolean>;

  downloadSubscription: Subscription;
  saveDataQueryModalSubscription: Subscription;

  constructor(
    private dialog: MatDialog,
    private saveDataQueryModalService: SaveDataQueryModalService,
    private uploadService: UploadService,
    private feasibilityQueryValidationService: FeasibilityQueryValidationService
  ) {}

  ngOnInit(): void {
    this.canDownload();
  }

  public upload(event: Event): void {
    const file: File = (event.target as HTMLInputElement).files[0];
    this.uploadService.uploadCRTDL(file);
  }

  private canDownload(): void {
    this.downloadAllowed$ = this.feasibilityQueryValidationService
      .getIsFeasibilityQueryValid()
      .pipe(map((isValid) => isValid && this.showDownload));
  }

  public downloadCRTDL(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    this.downloadSubscription?.unsubscribe();
    this.downloadSubscription = this.dialog
      .open(DownloadCRTDLComponent, dialogConfig)
      .afterClosed()
      .subscribe((isCancelled: boolean) => {});
  }

  public onSaveDataQuery(): void {
    this.saveDataQueryModalSubscription?.unsubscribe();
    this.saveDataQueryModalSubscription = this.saveDataQueryModalService
      .openSaveDataQueryModal()
      .subscribe();
  }
}
